/* Import libraries */
import React from "react";
import { connect } from "react-redux";
import { browserHistory } from "react-router";

import styles from "./css/SelectKeyContact.css";

/* Import actions */
import { updateConnectionKeyContact, loadContactCandidates } from "../actions";
import { publishMessage } from "../../notifications/actions";

/* Import components */
import CircleModal from "../../shared/components/widgets/static/CircleModal";
import Button from "../../shared/components/inputs/Button";
import Loader from "../../shared/components/widgets/static/Loader";
import OptionsDropdown from "../../shared/components/widgets/interactive/OptionsDropdown";

var SelectKeyContact = createClass({
  componentWillMount: function() {
    const { dispatch, params } = this.props;
    dispatch(loadContactCandidates());
  },

  notifyCounterParty: function() {
    const {
      dispatch,
      connectionId,
      ourEntityName,
      contactEntityId,
    } = this.props;
    var contactName = this.state.selectedContact.label;
    dispatch(
      publishMessage({
        text: `<strong>${contactName}</strong> has been assigned as the new key contact for your trade account with <strong>${ourEntityName}</strong>`,
        style: "connection",
        channel: "entity",
        channel_target: contactEntityId,
        intent: "view_connection",
        intent_target: connectionId,
      }),
    );
  },

  update: function() {
    const {
      dispatch,
      currentUserId,
      connectionId,
      connectionType,
    } = this.props;

    var notify = this.state.notify;
    var contactId = this.state.selectedContact.value;
    var that = this;

    dispatch(
      updateConnectionKeyContact(
        connectionType,
        connectionId,
        contactId,
        data => {
          // Individual contacts are notified via the API

          if (notify) {
            that.notifyCounterParty();
          }
          browserHistory.push(`/dashboard/connections/all`);
        },
      ),
    );
  },

  cancel: function() {
    const { location, connectionId } = this.props;
    browserHistory.push({
      pathname: `/dashboard/connections/details/${connectionId}`,
      query: location.query,
    });
  },

  getInitialState: function() {
    return {
      selectedContact: "",
      notify: false,
      showLoader: true,
    };
  },

  handleChange: function(v) {
    this.setState({ selectedContact: v });
  },

  toggleNotify: function(v) {
    if (this.state.notify) {
      this.setState({ notify: false });
    } else {
      this.setState({ notify: true });
    }
  },

  loadingComplete: function() {
    this.setState({
      showLoader: false,
    });
  },

  render: function() {
    const {
      title,
      button_label,
      loading,
      contacts,
      connectionType,
    } = this.props;
    const { loadingComplete } = this.state;

    let toggle_state = styles.default;

    if (loadingComplete) {
      return (
        <div className={styles.backdrop}>
          <Loader loader={loader} handleComplete={this.loadingComplete} />
        </div>
      );
    }

    if (this.state.notify) {
      toggle_state = styles.active;
    }

    return (
      <CircleModal title={title} dismissHandler={this.cancel}>
        <div className={styles.fieldset}>
          <OptionsDropdown
            handleChange={this.handleChange}
            label="Select new key contact"
            value={this.state.selectedContact}
            required={true}
            options={contacts}
          />

          <div className={toggle_state} onClick={this.toggleNotify}>
            {`inform ${connectionType} of change?`}
          </div>
        </div>
        <div className={styles.button}>
          <Button text={button_label} handleClick={this.update} />
        </div>
      </CircleModal>
    );
  },
});

var defaults = {
  title: "Select a new key contact?",
  button_label: "assign key contact",
};

module.exports = connect((state, ownProps) => {
  let currentUserId = state.current_user.data.data.id,
    connectionId = ownProps.params.connectionId,
    contacts = state.connections.contact_candidate_list;

  contacts = contacts.map(v => {
    return {
      value: v.id,
      label: v.attributes.full_name,
    };
  });

  let sc = state.connections,
    c = sc.connection,
    connectionType = c.relation_type,
    ourEntityName = c.ourparty.attributes.trading_name,
    contactEntityId = c.showparty.id,
    loading = contacts.length < 1 || sc.contact_candidate_list_loading;

  return {
    title: defaults.title,
    button_label: defaults.button_label,
    currentUserId,
    connectionId,
    loading,
    contacts,
    connectionType,
    ourEntityName,
    contactEntityId,
  };
})(SelectKeyContact);
